import * as React from "react";
import PostsStats from "@/components/PostsStats";
import { Dialog } from "@/components/ui";
import { SocialNetworksId } from "@/interfaces";
import { DesignPackageDetail, DesignPackageStatsResponse } from "@/services/bedrock/dtos/DesignPackage";

export interface AllPostsDialogProps {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  pkg: DesignPackageDetail;
  stats: DesignPackageStatsResponse | undefined;
  loading: boolean;
  onOpenPost: (postId: number, socialNetworkId: SocialNetworksId) => void;
}

export function AllPostsDialog({
  open,
  onOpenChange,
  pkg,
  stats,
  loading,
  onOpenPost,
}: AllPostsDialogProps): JSX.Element {
  return (
    <Dialog
      open={open}
      onOpenChange={next => onOpenChange(next)}
      size="3xl"
      showCloseButton
      className="flex flex-col max-h-[85vh]"
    >
      <Dialog.Header>
        <Dialog.Title>All posts from {pkg.name}</Dialog.Title>
      </Dialog.Header>
      <Dialog.Content className="flex-1 min-h-0 overflow-y-auto">
        <PostsStats
          stats={stats}
          type="Design"
          loading={loading}
          onRowClick={entry => {
            if (entry.postId != null) onOpenPost(entry.postId, entry.socialNetworkId);
          }}
        />
      </Dialog.Content>
    </Dialog>
  );
}
